import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import classes from "./ViewerTree.module.css";
import { Structure } from "bimatter-viewer/dist/Model/Model.types";
import { useAppSelector, useViewer } from "../../../app/hooks/hooks";
import TreeContextMenu from "./TreeContextMenu";
import { Chunk } from "./ViewerTree";
import { selectModels } from "../../../app/features/viewer/viewerMainSlice";
import { useGetModelNameMutation } from "../../../app/services/files/files";
interface ViewerTreeElementProps {
    chunk: Chunk;
    modelID: number;
    search: string;
    hideTrigger: () => void;
    selectTrigger: () => void;
    selected: Set<number>;
}
const ViewerTreeElement: React.FC<ViewerTreeElementProps> = ({
    chunk,
    modelID,
    search,
    hideTrigger,
    selected,
    selectTrigger,
}) => {
    const defActiveTypes = ["IFCPROJECT", "IfcSite", "IfcBuilding"];
    const viewer = useViewer();
    const models = useAppSelector(selectModels);
    const [hovered, setHovered] = useState(false);
    const [active, setActive] = useState(defActiveTypes.includes(chunk.type));
    const [getModelName] = useGetModelNameMutation();
    const [showContext, setShowContext] = useState<{
        x: number;
        y: number;
    } | null>(null);
    const colorise = true;

    const span_onclick_handle = () => {
        if (active) {
            setActive(false);
        } else {
            setActive(true);
        }
    };
    function getChunkChildrenIds(chunk: Structure, idsArr: number[]) {
        if (chunk.children.length) {
            chunk.children.forEach((child) => {
                getChunkChildrenIds(child, idsArr);
            });
        } else {
            idsArr.push(chunk.id);
        }
    }
    const getIds = () => {
        if (!viewer) return [];
        const ids: number[] = chunk.children.length ? [] : [chunk.id];
        chunk.children.forEach((child) => {
            getChunkChildrenIds(child, ids);
        });
        return ids;
    };
    let curValue = chunk.name;
    if (chunk.type === "none") {
        curValue = "no model structure";
    }
    if (!curValue) {
        const props = viewer?.models[modelID].properties.data[chunk.id];
        if (props) {
            curValue = props.props.name ? props.props.name : chunk.type;
        } else {
            curValue = chunk.type;
        }
    }
    const [value, setValue] = useState(curValue);
    useEffect(() => {
        if (chunk.type === "IFCPROJECT") {
            const model_id = models[modelID].model_id
                .split(".min")[0]
                .split("/")
                .pop()!;
            getModelName(model_id)
                .unwrap()
                .then((name) => {
                    setValue(name);
                });
        }
    }, []);

    return (
        <li key={chunk.id} className={classes.tree__li}>
            {selected.has(chunk.id) && (
                <div className={classes.tree__li_bg_wrap}>
                    <div className={classes.tree__li_bg}></div>
                </div>
            )}
            {hovered && (
                <div className={classes.tree__li_bg_wrap}>
                    <div className={classes.tree__li_hover}></div>
                </div>
            )}
            <span
                onClick={(e) => {
                    if (
                        viewer &&
                        !chunk.children.length &&
                        viewer.models[modelID].activeElements.has(chunk.id)
                    ) {
                        viewer.selector.selection.selectByIds(
                            modelID,
                            [chunk.id],
                            !e.shiftKey
                        );
                        selectTrigger();
                    }
                }}
                className={[
                    active ? classes.caret_down : "",
                    classes.caret,
                    chunk.children.length && classes.caret_before,
                    chunk.hidden && classes.hidden,
                    search && value.toLowerCase().toLowerCase().includes(search)
                        ? classes.searched
                        : "",
                ].join(" ")}
                onContextMenu={(e) => {
                    const element = e.target as HTMLElement;
                    const elemRect = element.getBoundingClientRect();
                    const left = e.clientX - elemRect.left + 20;
                    setShowContext({
                        x: left > 200 ? 200 : left,
                        y: e.clientY - elemRect.top,
                    });
                }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                <TreeContextMenu
                    position={showContext}
                    setPosition={setShowContext}
                    getIds={getIds}
                    modelID={modelID}
                    selectTrigger={selectTrigger}
                    hideTrigger={hideTrigger}
                ></TreeContextMenu>
                <div className={classes.item__wrap}>
                    <div
                        className={classes.item__lable}
                        style={{
                            width: "calc(100% - 50px)",
                            color: !colorise ? "#CDCDCD" : "",
                        }}
                        onClick={span_onclick_handle}
                        title={value}
                    >
                        {value}
                    </div>
                    {/* <div className={classes.eye__checkbox}>
                        <input
                            className={classes.check}
                            type="checkbox"
                            id={chunk.id.toString()}
                            // modelID={modelID}
                            checked={visible}
                            onChange={eye_click}
                        ></input>
                        <span
                            className={classes.checkmark__eye}
                            onClick={(e: any) => {
                                e.target.parentNode?.children[0].click();
                            }}
                        ></span>
                    </div>
                    <div className={classes.tree__checkbox}>
                        <input
                            ref={ref}
                            className={classes.check}
                            type="checkbox"
                            id={chunk.id.toString()}
                            // modelID={modelID}
                            checked={checked}
                            onChange={checkBox_click}
                        ></input>
                        <span
                            className={classes.checkmark}
                            onClick={(e: any) => {
                                e.target.parentNode?.children[0].click();
                            }}
                        ></span>
                    </div> */}
                </div>
            </span>

            <ul
                className={[classes.nested, active ? classes.active : ""].join(
                    " "
                )}
            >
                {active &&
                    chunk.children.map((param) => (
                        <ViewerTreeElement
                            key={param.id}
                            chunk={param as Chunk}
                            modelID={modelID}
                            search={search}
                            hideTrigger={hideTrigger}
                            selected={selected}
                            selectTrigger={selectTrigger}
                        ></ViewerTreeElement>
                    ))}
            </ul>
        </li>
    );
};

export default ViewerTreeElement;
